import { HiOutlineUser } from "react-icons/hi2";

export const PersonIcon = ({ width, height, color, ...props }) => (
  <HiOutlineUser
    size={width || height || 24}
    color={color || "currentColor"}
    {...props}
  />
);
